// Angular
import {
  Component,
  Input,
  Output,
  EventEmitter,
  OnInit,
  ChangeDetectionStrategy,
} from '@angular/core';

@Component({
  selector: 'filter-header',
  templateUrl: 'filter-header.component.html',
  styleUrls: ['./filter-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FilterHeaderComponent implements OnInit {
  @Input() selectedOptionsCount: number = 0;
  @Input() headingText: string;
  @Input() isExpanded: boolean = true;
  @Output() expandedChanged: EventEmitter<boolean> = new EventEmitter();

  get shouldDisplaySelectedOptionsCount(): boolean {
    return this.selectedOptionsCount > 0;
  }

  constructor() {}

  ngOnInit() {}

  onExpandedChanged(): void {
    this.isExpanded = !this.isExpanded;
    this.expandedChanged.emit(this.isExpanded);
  }
}
